import { apiInstance } from 'api/utils';
// TODO: remove test1 from url

// Existing policies
const existingPoliciesApi = {
  getExistingPolicies: ({ portfolio }: { portfolio: any }) => {
    return apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/existing-policies/`
    });
  },
  addExistingPolicy: ({
    portfolio,
    policy
  }: {
    portfolio: any;
    policy: any;
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/existing-policies/`,
      data: policy
    });
  },
  editExistingPolicy: ({
    portfolio,
    policy
  }: {
    portfolio: any;
    policy: any;
  }) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/cases/${portfolio}/existing-policies/${policy.id}/`,
      data: policy
    });
  },
  deleteExistingPolicy: ({
    portfolio,
    policyId
  }: {
    portfolio: any;
    policyId: any;
  }) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/cases/${portfolio}/existing-policies/${policyId}/`
    });
  },
  calculateCharges: ({
    portfolio,
    data
  }: {
    portfolio: any;
    data: {
      policy: any;
      other_policies: any;
    };
  }) => {
    return apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/charges-existing`,
      data: data
    });
  }
};

export default {
  ...existingPoliciesApi
};
